import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { stepContent, header, singleInput } from "./../style";
import AutoSuggestForm from "../../../../../shared/atoms/AutoSuggestForm";

import { useNewOfferMobile } from "../../context";
import InfoBankStep from "./infosSeeMore/InfoBankStep"

const BankInput = ({ step, bankData, options, onChangeBankData }) => {
	const { setStepError } = useNewOfferMobile();

	const [state, setState] = useState({
		bankId: bankData.data.bankId,
		agency: bankData.data.agency,
		account: bankData.data.account,
		type: bankData.data.type,
		hasError: false
	});

	useEffect(() => {
		setStepError(!state.bankId);
	}, [state]);

	const onChange = ev => {
		let bankId = ev.target.value;
		let agency = "";
		let account = "";
		let type = "c";

		setState({
			...state,
			bankId,
			agency,
			account,
			type,
			hasError: !bankId
		});

		onChangeBankData({ bankId, agency, account, type });
	};

	return (
		<div
			className={css`
				${stepContent};
			`}
		>
			<strong
				className={css`
					${header};
				`}
			>
				Dados bancários
			</strong>
			<div
				className={css`
					${singleInput};
				`}
			>
				<AutoSuggestForm
					name="bankId"
					options={options}
					defaultValue={state.bankId}
					onChange={onChange}
					label="Banco"
					suggestionKeyToRender="label"
					suggestionKeyValueToUse="label"
					hasError={state.hasError}
					errorMessage="É necessário selecionar um banco."
					data-action="register-bank-details-bank-select"
				/>
			</div>

			<InfoBankStep/>
		</div>
	);
};

export default BankInput;
